import { Component, h } from 'preact';

import { DataStoreEvent } from 'common/module/data/store.event';
import { DropdownComponentPropsInterface } from 'common/module/dropdown/component-props.interface';
import { DropdownTemplate } from 'common/module/dropdown/template';
import { DropdownTemplatePropsInterface } from 'common/module/dropdown/template-props.interface';
import { DropdownViewStore } from 'common/module/dropdown/view-store';
import { DropdownViewStoreEvent } from 'common/module/dropdown/view-store.event';
import { DropdownViewStoreFactory } from 'common/module/dropdown/view-store.factory';
import { DropdownViewStoreOptionsInterface } from 'common/module/dropdown/view-store-options.interface';

export class DropdownComponent extends Component<DropdownComponentPropsInterface, DropdownTemplatePropsInterface> {
  /**
   * Dropdown view store
   */
  private dropdownViewStore: DropdownViewStore;

  /**
   * Constructor
   */
  constructor() {
    super();

    this.dropdownViewStore = DropdownViewStoreFactory();
    this.dropdownViewStore.initialize();
    this.setState(this.dropdownViewStore.getState());
  }

  /**
   * @inheritDoc
   */
  public componentWillMount(): void {
    this.dropdownViewStore.initialize(this.props);
    this.setState(this.dropdownViewStore.getState());

    this.dropdownViewStore.getEventEmitter().addListener(DataStoreEvent.updateState, this.onUpdateStateStore);
    this.dropdownViewStore.getEventEmitter().addListener(DropdownViewStoreEvent.change, this.onChangeStore);
    this.dropdownViewStore.getEventEmitter().addListener(DropdownViewStoreEvent.clickWindow, this.onClickWindow);
    this.dropdownViewStore.getEventEmitter().addListener(DropdownViewStoreEvent.close, this.onClose);
  }

  /**
   * @inheritDoc
   */
  public componentWillUnmount(): void {
    this.dropdownViewStore.getEventEmitter().removeListener(DataStoreEvent.updateState, this.onUpdateStateStore);
    this.dropdownViewStore.getEventEmitter().removeListener(DropdownViewStoreEvent.change, this.onChangeStore);
    this.dropdownViewStore.getEventEmitter().removeListener(DropdownViewStoreEvent.clickWindow, this.onClickWindow);
    this.dropdownViewStore.getEventEmitter().removeListener(DropdownViewStoreEvent.close, this.onClose);
  }

  /**
   * @inheritDoc
   */
  public componentWillReceiveProps(nextProps: DropdownViewStoreOptionsInterface): void {
    this.dropdownViewStore.initialize(nextProps);
    this.setState(this.dropdownViewStore.getState());
  }

  /**
   * Render the component
   */
  public render(): preact.JSX.Element {
    const { isLoading, errorClass, isError, isDisabled, isNew, selectedElement, onFocus, onBlur } = this.props;

    return (
      <DropdownTemplate
        {...{
          ...this.state,
          isLoading,
          errorClass,
          isError,
          isDisabled,
          isNew,
          onFocus,
          onBlur,
          selectedElement,
        }}
      />
    );
  }

  /**
   * Update the component state
   */
  private onUpdateStateStore = (): void => {
    this.setState(this.dropdownViewStore.getState());
  };

  /**
   * Change was fired from the store
   */
  private onChangeStore = (value: string | string[]): void => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  /**
   * Clicked window
   */
  private onClickWindow = (e: Event): void => {
    if (this.base.contains(e.target as HTMLElement)) {
      return;
    }

    this.dropdownViewStore.close();
  };

  /**
   * Dropdown closed
   */
  private onClose = (): void => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
}
